import { Error404Component } from './../error/404.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { authProviders, AuthGuard} from '../../auth.guard';
import { ModuleWithProviders } from '@angular/core';
import { PatientDetailComponent } from './patient-detail/patient-detail.component';
import { MedicalConditionsComponent } from './medical-conditions/medical-conditions.component';
import { RecordPreviousVaccinesComponent } from './record-previous-vaccines/record-previous-vaccines.component';
import { SelectDiseaseComponent } from './select-disease/select-disease.component';
import { PrescribeVaccinationComponent } from './prescribe-vaccination/prescribe-vaccination.component';
import { TripInformationComponent } from './trip-information/trip-information.component';
import { ConsultationProcessComponent } from './consultation-process.component';
import { SelectPrescriptionComponent } from './select-prescriptions/select-prescriptions.component';
import { LabTestComponent } from './lab-tests/lab-tests.component';
import { SaveConsultationComponent } from './save-consultation/save-consultation.component';
import { AdministerVaccineComponent } from './administer-vaccine/administer-vaccine.component';
import { ConfirmationLabTestComponent } from './confirmation-lab-tests/confirmation-lab-tests.component';
import { GroupRecommendedDiseaseComponent } from './group-recommended-disease/group-recommended-disease.component';
import { GroupRecommendedPrescriptionsComponent } from './group-recommended-prescriptions/group-recommended-prescriptions.component';
import { GroupRecommendedLabTestsComponent } from './group-recommended-lab-tests/group-recommended-lab-tests.component';
const consultationProcessRoutes: Routes = [{
  path: '',
  canActivateChild: [AuthGuard],
  component: ConsultationProcessComponent,
  children: [
    { path: 'patient-detail/:id/:patientId', component: PatientDetailComponent },
    { path: 'trip-information/:id/:patientId', component: TripInformationComponent },
    { path: 'trip-information/:id', component: TripInformationComponent },
    { path: 'medical-conditions/:id/:patientId', component: MedicalConditionsComponent },
    { path: 'record-previous-vaccines/:id/:patientId', component: RecordPreviousVaccinesComponent },
    { path: 'select-disease/:id/:patientId', component: SelectDiseaseComponent },
    { path: 'prescribe-vaccination/:id/:patientId', component: PrescribeVaccinationComponent },
    { path: 'select-prescriptions/:id/:patientId', component: SelectPrescriptionComponent },
    { path: 'lab-tests/:id/:patientId', component: LabTestComponent },
    { path: 'save-consultation/:id/:patientId', component: SaveConsultationComponent },
    { path: 'administer-vaccine/:id/:patientId', component: AdministerVaccineComponent },
    { path: 'confirmation-lab-tests/:id/:patientId', component: ConfirmationLabTestComponent },
    { path: 'group-recommended-diseases/:id', component: GroupRecommendedDiseaseComponent },
    { path: 'group-recommended-prescriptions/:id', component: GroupRecommendedPrescriptionsComponent },
    { path: 'group-recommended-lab-tests/:id', component: GroupRecommendedLabTestsComponent },
    { path: 'group-template-trip-information/:id', component: TripInformationComponent },
    { path: 'group-template-recommended-diseases/:id', component: GroupRecommendedDiseaseComponent },
    { path: 'group-template-recommended-prescriptions/:id', component: GroupRecommendedPrescriptionsComponent },
    { path: 'group-template-recommended-lab-tests/:id', component: GroupRecommendedLabTestsComponent }
  ]
}];

@NgModule({
  imports: [
    RouterModule.forChild(consultationProcessRoutes)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})

export class ConsultationProcessRoutingModule { }



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/consultation-process/consultation-process.routing.ts